import type { MessageKey } from 'types/LocaleMessageKey';

import {
  ERROR_EXPIRED,
  ERROR_NO_USES_REMAIN,
  MESSAGE_ERROR_DEFAULT,
  MESSAGE_ERROR_EXPIRED,
  MESSAGE_ERROR_USED,
} from '@/app/[locale]/product/_consts/discounts';

import type { NonSiteWideMessage } from './types';

const _invalidMessages = (reason?: string) => {
  switch (reason) {
    case ERROR_NO_USES_REMAIN:
      return MESSAGE_ERROR_USED;

    case ERROR_EXPIRED:
      return MESSAGE_ERROR_EXPIRED;

    default:
      return MESSAGE_ERROR_DEFAULT;
  }
};

export const _getNonSiteWideMessage = ({
  errorCode,
  errorMessage,
  hasSitewideDiscountOnly,
  reason,
}: NonSiteWideMessage): MessageKey | null | undefined => {
  /*
   * errors and/or invalid states from non-sitewide codes
   * should not be displayed during sitwide promotions
   */
  if (hasSitewideDiscountOnly) return null;
  if (errorMessage) return errorMessage;
  if (reason) return _invalidMessages(reason);
  if (errorCode) return _invalidMessages();

  return undefined;
};
